export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	toxelhisui: {
		learnset: {
			acid: ["9L1", "8L1", "8S0"],
			attract: ["8M"],
			belch: ["9L1", "8L1"],
			charm: ["9M"],
			encore: ["9M", "8M"],
			endeavor: ["9M", "9E", "8E"],
			endure: ["9M", "8M"],
			facade: ["9M", "8M"],
			flail: ["9L1", "8L1", "8S0"],
			growl: ["9L1", "8L1", "8S0"],
			metalsound: ["9M", "9E", "8E"],
			nuzzle: ["9L1", "8L1", "8S0"],
			poweruppunch: ["8E"],
			protect: ["9M", "8M"],
			rest: ["9M", "8M"],
			round: ["8M"],
			sleeptalk: ["9M", "8M"],
			snore: ["8M"],
			substitute: ["9M", "8M"],
			tearfullook: ["9L1", "8L1"],
			terablast: ["9M"],
			highjumpkick: ["9L1"],
			knockoff: ["9L1"],
			stealthrock: ["9L1"],
			toxicspikes: ["9L1"],
			drainpunch: ["9L1"],
			machpunch: ["9L1"],
			uturn: ["9L1"],
			slackoff: ["9L1"],
			toxic: ["9L1"],
			sludgebomb: ["9L1"],
			gunkshot: ["9L1"],
			rockslide: ["9L1"],
		},
	},
	baltoygearrider: {
		learnset: {
			allyswitch: ["9L1"],
			ancientpower: ["9L1"],
			bulldoze: ["9L1"],
			calmmind: ["9L1"],
			chargebeam: ["9L1"],
			confide: ["9L1"],
			confusion: ["9L1"],
			cosmicpower: ["9L1"],
			dazzlinggleam: ["9L1"],
			dig: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			dreameater: ["9L1"],
			drillrun: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			eerieimpulse: ["9L1"],
			endure: ["9L1"],
			expandingforce: ["9L1"],
			explosion: ["9L1"],
			extrasensory: ["9L1"],
			facade: ["9L1"],
			flash: ["9L1"],
			frustration: ["9L1"],
			grassknot: ["9L1"],
			gravity: ["9L1"],
			guardsplit: ["9L1"],
			guardswap: ["9L1"],
			gyroball: ["9L1"],
			harden: ["9L1"],
			headbutt: ["9L1"],
			healblock: ["9L1"],
			hex: ["9L1"],
			hiddenpower: ["9L1"],
			icebeam: ["9L1"],
			imprison: ["9L1"],
			lightscreen: ["9L1"],
			magiccoat: ["9L1"],
			mimic: ["9L1"],
			mudslap: ["9L1"],
			naturalgift: ["9L1"],
			powersplit: ["9L1"],
			powerswap: ["9L1"],
			powertrick: ["9L1"],
			protect: ["9L1"],
			psybeam: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			psychicterrain: ["9L1"],
			psyshock: ["9L1"],
			raindance: ["9L1"],
			rapidspin: ["9L1"],
			recycle: ["9L1"],
			reflect: ["9L1"],
			refresh: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			rockpolish: ["9L1"],
			rockslide: ["9L1"],
			rocktomb: ["9L1"],
			round: ["9L1"],
			safeguard: ["9L1"],
			sandtomb: ["9L1"],
			sandstorm: ["9L1"],
			scorchingsands: ["9L1"],
			secretpower: ["9L1"],
			selfdestruct: ["9L1"],
			shadowball: ["9L1"],
			signalbeam: ["9L1"],
			skillswap: ["9L1"],
			sleeptalk: ["9L1"],
			smackdown: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			stealthrock: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swagger: ["9L1"],
			telekinesis: ["9L1"],
			toxic: ["9L1"],
			trick: ["9L1"],
			trickroom: ["9L1"],
			wonderroom: ["9L1"],
			zenheadbutt: ["9L1"],
			assurance: ["9L1"],
			autotomize: ["9L1"],
			bind: ["9L1"],
			charge: ["9L1"],
			discharge: ["9L1"],
			flashcannon: ["9L1"],
			geargrind: ["9L1"],
			hyperbeam: ["9L1"],
			irondefense: ["9L1"],
			lockon: ["9L1"],
			magnetrise: ["9L1"],
			metalsound: ["9L1"],
			mirrorshot: ["9L1"],
			powergem: ["9L1"],
			risingvoltage: ["9L1"],
			rocksmash: ["9L1"],
			screech: ["9L1"],
			shiftgear: ["9L1"],
			shockwave: ["9L1"],
			steelbeam: ["9L1"],
			steelroller: ["9L1"],
			thundershock: ["9L1"],
			thunderwave: ["9L1"],
			thunderbolt: ["9L1"],
			uproar: ["9L1"],
			visegrip: ["9L1"],
			voltswitch: ["9L1"],
			wildcharge: ["9L1"],
			zapcannon: ["9L1"],
		},
	},
	baltoywaterrider: {
		learnset: {
			agility: ["9L1"],
			allyswitch: ["9L1"],
			ancientpower: ["9L1"],
			attract: ["9L1"],
			aurorabeam: ["9L1"],
			bide: ["9L1"],
			blizzard: ["9L1"],
			bounce: ["9L1"],
			brine: ["9L1"],
			bubble: ["9L1"],
			bubblebeam: ["9L1"],
			bulldoze: ["9L1"],
			calmmind: ["9L1"],
			captivate: ["9L1"],
			chargebeam: ["9L1"],
			chillingwater: ["9L1"],
			clearsmog: ["9L1"],
			confide: ["9L1"],
			confusion: ["9L1"],
			cosmicpower: ["9L1"],
			curse: ["9L1"],
			dazzlinggleam: ["9L1"],
			dig: ["9L1"],
			disable: ["9L1"],
			dive: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			dragonbreath: ["9L1"],
			dragondance: ["9L1"],
			dragonpulse: ["9L1"],
			dragonrage: ["9L1"],
			dreameater: ["9L1"],
			drillrun: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			eerieimpulse: ["9L1"],
			endure: ["9L1"],
			expandingforce: ["9L1"],
			explosion: ["9L1"],
			extrasensory: ["9L1"],
			facade: ["9L1"],
			flail: ["9L1"],
			flash: ["9L1"],
			flashcannon: ["9L1"],
			flipturn: ["9L1"],
			focusenergy: ["9L1"],
			frustration: ["9L1"],
			gigaimpact: ["9L1"],
			grassknot: ["9L1"],
			gravity: ["9L1"],
			guardsplit: ["9L1"],
			guardswap: ["9L1"],
			gyroball: ["9L1"],
			hail: ["9L1"],
			harden: ["9L1"],
			headbutt: ["9L1"],
			healblock: ["9L1"],
			hex: ["9L1"],
			hiddenpower: ["9L1"],
			hydropump: ["9L1"],
			hyperbeam: ["9L1"],
			icebeam: ["9L1"],
			icywind: ["9L1"],
			imprison: ["9L1"],
			laserfocus: ["9L1"],
			leer: ["9L1"],
			lightscreen: ["9L1"],
			liquidation: ["9L1"],
			magiccoat: ["9L1"],
			mimic: ["9L1"],
			mudslap: ["9L1"],
			muddywater: ["9L1"],
			naturalgift: ["9L1"],
			octazooka: ["9L1"],
			outrage: ["9L1"],
			powersplit: ["9L1"],
			powerswap: ["9L1"],
			powertrick: ["9L1"],
			protect: ["9L1"],
			psybeam: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			psychicterrain: ["9L1"],
			psyshock: ["9L1"],
			rage: ["9L1"],
			raindance: ["9L1"],
			rapidspin: ["9L1"],
			razorwind: ["9L1"],
			recycle: ["9L1"],
			reflect: ["9L1"],
			refresh: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			rockpolish: ["9L1"],
			rockslide: ["9L1"],
			rocktomb: ["9L1"],
			round: ["9L1"],
			safeguard: ["9L1"],
			sandtomb: ["9L1"],
			sandstorm: ["9L1"],
			scald: ["9L1"],
			scaleshot: ["9L1"],
			scaryface: ["9L1"],
			scorchingsands: ["9L1"],
			secretpower: ["9L1"],
			selfdestruct: ["9L1"],
			shadowball: ["9L1"],
			signalbeam: ["9L1"],
			skillswap: ["9L1"],
			skullbash: ["9L1"],
			sleeptalk: ["9L1"],
			smackdown: ["9L1"],
			smokescreen: ["9L1"],
			snore: ["9L1"],
			snowscape: ["9L1"],
			solarbeam: ["9L1"],
			splash: ["9L1"],
			stealthrock: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			surf: ["9L1"],
			swagger: ["9L1"],
			swift: ["9L1"],
			takedown: ["9L1"],
			telekinesis: ["9L1"],
			terablast: ["9L1"],
			toxic: ["9L1"],
			trick: ["9L1"],
			trickroom: ["9L1"],
			twister: ["9L1"],
			watergun: ["9L1"],
			waterpulse: ["9L1"],
			waterfall: ["9L1"],
			weatherball: ["9L1"],
			whirlpool: ["9L1"],
			wonderroom: ["9L1"],
			zenheadbutt: ["9L1"],
		},
	},

	// Slate 2

	houndour: {
		learnset: {
			beatup: ["9L1"],
			bite: ["9L1"],
			bodyslam: ["9L1"],
			burningjealousy: ["9L1"],
			comeuppance: ["9L1"],
			counter: ["9L1"],
			crunch: ["9L1"],
			darkpulse: ["9L1"],
			destinybond: ["9L1"],
			doubleedge: ["9L1"],
			ember: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			feint: ["9L1"],
			fireblast: ["9L1"],
			firefang: ["9L1"],
			firespin: ["9L1"],
			flamecharge: ["9L1"],
			flamethrower: ["9L1"],
			flareblitz: ["9L1"],
			foulplay: ["9L1"],
			heatwave: ["9L1"],
			helpinghand: ["9L1"],
			howl: ["9L1"],
			hypervoice: ["9L1"],
			incinerate: ["9L1"],
			inferno: ["9L1"],
			lashout: ["9L1"],
			leer: ["9L1"],
			mudshot: ["9L1"],
			mudslap: ["9L1"],
			nastyplot: ["9L1"],
			overheat: ["9L1"],
			painsplit: ["9L1"],
			protect: ["9L1"],
			psychicfangs: ["9L1"],
			raindance: ["9L1"],
			rest: ["9L1"],
			reversal: ["9L1"],
			roar: ["9L1"],
			scaryface: ["9L1"],
			shadowball: ["9L1"],
			sleeptalk: ["9L1"],
			sludgebomb: ["9L1"],
			smog: ["9L1"],
			snarl: ["9L1"],
			solarbeam: ["9L1"],
			spite: ["9L1"],
			substitute: ["9L1"],
			suckerpunch: ["9L1"],
			sunnyday: ["9L1"],
			superfang: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			temperflare: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			thunderfang: ["9L1"],
			torment: ["9L1"],
			toxic: ["9L1"],
			trailblaze: ["9L1"],
			willowisp: ["9L1"],
			knockoff: ["9L1"],
			slackoff: ["9L1"],
			friendlyfire: ["9L1"],
			baddybad: ["9L1"],
		},
	},
	koffinghoenn: {
		learnset: {
			acidspray: ["9L1"],
			assurance: ["9L1"],
			belch: ["9L1"],
			bodyslam: ["9L1"],
			clearsmog: ["9L1"],
			curse: ["9L1"],
			darkpulse: ["9L1"],
			destinybond: ["9L1"],
			endure: ["9L1"],
			explosion: ["9L1"],
			facade: ["9L1"],
			fireblast: ["9L1"],
			gunkshot: ["9L1"],
			gyroball: ["9L1"],
			haze: ["9L1"],
			memento: ["9L1"],
			painsplit: ["9L1"],
			poisongas: ["9L1"],
			protect: ["9L1"],
			psybeam: ["9L1"],
			raindance: ["9L1"],
			rest: ["9L1"],
			scaryface: ["9L1"],
			selfdestruct: ["9L1"],
			shadowball: ["9L1"],
			sleeptalk: ["9L1"],
			sludge: ["9L1"],
			sludgebomb: ["9L1"],
			sludgewave: ["9L1"],
			smog: ["9L1"],
			smokescreen: ["9L1"],
			spitup: ["9L1"],
			spite: ["9L1"],
			stockpile: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swallow: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			thunder: ["9L1"],
			thunderbolt: ["9L1"],
			toxic: ["9L1"],
			toxicspikes: ["9L1"],
			venoshock: ["9L1"],
			willowisp: ["9L1"],
			hydropump: ["9L1"],
			liquidation: ["9L1"],
			flipturn: ["9L1"],
			scald: ["9L1"],
			waterfall: ["9L1"],
			aquaring: ["9L1"],
			bubble: ["9L1"],
			withdraw: ["9L1"],
			watergun: ["9L1"],
			soak: ["9L1"],
			surf: ["9L1"],
		},
	},
	hakamoo: {
		learnset: {
			aerialace: ["9L1"],
			bodyslam: ["9L1"],
			breakingswipe: ["9L1"],
			brickbreak: ["9L1"],
			bulkup: ["9L1"],
			bulldoze: ["9L1"],
			closecombat: ["9L1"],
			coaching: ["9L1"],
			counter: ["9L1"],
			doubleedge: ["9L1"],
			dracometeor: ["9L1"],
			dragonbreath: ["9L1"],
			dragoncheer: ["9L1"],
			dragonclaw: ["9L1"],
			dragondance: ["9L1"],
			dragonpulse: ["9L1"],
			dragontail: ["9L1"],
			drainpunch: ["9L1"],
			earthquake: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			falseswipe: ["9L1"],
			fling: ["9L1"],
			focusblast: ["9L1"],
			focuspunch: ["9L1"],
			headbutt: ["9L1"],
			irondefense: ["9L1"],
			ironhead: ["9L1"],
			leer: ["9L1"],
			lowkick: ["9L1"],
			metalclaw: ["9L1"],
			nobleroar: ["9L1"],
			outrage: ["9L1"],
			protect: ["9L1"],
			rest: ["9L1"],
			reversal: ["9L1"],
			roar: ["9L1"],
			rockslide: ["9L1"],
			rocktomb: ["9L1"],
			sandstorm: ["9L1"],
			scaleshot: ["9L1"],
			scaryface: ["9L1"],
			screech: ["9L1"],
			shadowclaw: ["9L1"],
			sleeptalk: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swordsdance: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			terablast: ["9L1"],
			throatchop: ["9L1"],
			upperhand: ["9L1"],
			vacuumwave: ["9L1"],
			workup: ["9L1"],
			xscissor: ["9L1"],
			clangoroussoul: ["9L1"],
			flashcannon: ["9L1"],
			stealthrock: ["9L1"],
		},
	},
	kartana: {
		learnset: {
			aerialace: ["9L1"],
			aircutter: ["9L1"],
			airslash: ["9L1"],
			brickbreak: ["9L1"],
			calmmind: ["9L1"],
			confide: ["9L1"],
			cut: ["9L1"],
			defog: ["9L1"],
			detect: ["9L1"],
			doubleteam: ["9L1"],
			endure: ["9L1"],
			falseswipe: ["9L1"],
			furycutter: ["9L1"],
			gigadrain: ["9L1"],
			gigaimpact: ["9L1"],
			guillotine: ["9L1"],
			irondefense: ["9L1"],
			knockoff: ["9L1"],
			laserfocus: ["9L1"],
			lastresort: ["9L1"],
			leafblade: ["9L1"],
			nightslash: ["9L1"],
			protect: ["9L1"],
			psychocut: ["9L1"],
			razorleaf: ["9L1"],
			rest: ["9L1"],
			round: ["9L1"],
			sacredsword: ["9L1"],
			screech: ["9L1"],
			sleeptalk: ["9L1"],
			smartstrike: ["9L1"],
			snore: ["9L1"],
			solarblade: ["9L1"],
			steelbeam: ["9L1"],
			strengthsap: ["9L1"],
			substitute: ["9L1"],
			swagger: ["9L1"],
			swordsdance: ["9L1"],
			synthesis: ["9L1"],
			tailwind: ["9L1"],
			toxic: ["9L1"],
			vacuumwave: ["9L1"],
			xscissor: ["9L1"],
		},
	},
	ledyba: {
		learnset: {
			acrobatics: ["9L1"],
			aerialace: ["9L1"],
			agility: ["9L1"],
			aircutter: ["9L1"],
			airslash: ["9L1"],
			attract: ["9L1"],
			batonpass: ["9L1"],
			bide: ["9L1"],
			brickbreak: ["9L1"],
			bugbite: ["9L1"],
			bugbuzz: ["9L1"],
			captivate: ["9L1"],
			cometpunch: ["9L1"],
			confide: ["9L1"],
			counter: ["9L1"],
			curse: ["9L1"],
			dig: ["9L1"],
			dizzypunch: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			drainpunch: ["9L1"],
			dynamicpunch: ["9L1"],
			encore: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			flash: ["9L1"],
			fling: ["9L1"],
			focuspunch: ["9L1"],
			frustration: ["9L1"],
			gigadrain: ["9L1"],
			headbutt: ["9L1"],
			hiddenpower: ["9L1"],
			icepunch: ["9L1"],
			infestation: ["9L1"],
			knockoff: ["9L1"],
			lightscreen: ["9L1"],
			machpunch: ["9L1"],
			megapunch: ["9L1"],
			mimic: ["9L1"],
			naturalgift: ["9L1"],
			ominouswind: ["9L1"],
			poweruppunch: ["9L1"],
			protect: ["9L1"],
			psybeam: ["9L1"],
			reflect: ["9L1"],
			refresh: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			rollout: ["9L1"],
			roost: ["9L1"],
			round: ["9L1"],
			safeguard: ["9L1"],
			screech: ["9L1"],
			secretpower: ["9L1"],
			silverwind: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			stringshot: ["9L1"],
			strugglebug: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			supersonic: ["9L1"],
			swagger: ["9L1"],
			sweetscent: ["9L1"],
			swift: ["9L1"],
			swordsdance: ["9L1"],
			tackle: ["9L1"],
			tailwind: ["9L1"],
			thief: ["9L1"],
			thunderpunch: ["9L1"],
			toxic: ["9L1"],
			uturn: ["9L1"],
			uproar: ["9L1"],
			ladybugdance: ["9L1"],
			icebeam: ["9L1"],
		},
	},
	wooperpaldea: {
		learnset: {
			acidspray: ["9M", "9E"],
			afteryou: ["9E"],
			amnesia: ["9M", "9L32"],
			ancientpower: ["9E"],
			bodypress: ["9M"],
			bodyslam: ["9M"],
			bulldoze: ["9M"],
			chillingwater: ["9M"],
			counter: ["9E"],
			curse: ["9M", "9E"],
			dig: ["9M"],
			doubleedge: ["9M"],
			doublekick: ["9E"],
			earthpower: ["9M"],
			earthquake: ["9M", "9L40"],
			endure: ["9M"],
			facade: ["9M"],
			gunkshot: ["9M"],
			haze: ["9M", "9E"],
			helpinghand: ["9M"],
			hydropump: ["9M"],
			liquidation: ["9M"],
			lowkick: ["9M"],
			mist: ["9E"],
			mudshot: ["9M", "9L1"],
			mudslap: ["9M"],
			poisonjab: ["9M", "9L24"],
			poisontail: ["9M", "9L8"],
			protect: ["9M"],
			raindance: ["9M"],
			recover: ["9E"],
			rest: ["9M"],
			rockslide: ["9M"],
			rocktomb: ["9M"],
			sandstorm: ["9M"],
			slam: ["9L16"],
			sleeptalk: ["9M"],
			sludgebomb: ["9M"],
			sludgewave: ["9M", "9L28"],
			spikes: ["9M"],
			spitup: ["9E"],
			stealthrock: ["9M"],
			stockpile: ["9E"],
			stompingtantrum: ["9M"],
			stoneedge: ["9M"],
			substitute: ["9M"],
			surf: ["9M"],
			swallow: ["9E"],
			tackle: ["9L4"],
			tailwhip: ["9L1"],
			takedown: ["9M"],
			terablast: ["9M"],
			toxic: ["9M", "9L36"],
			toxicspikes: ["9M", "9L12"],
			trailblaze: ["9M"],
			venoshock: ["9M"],
			waterfall: ["9M"],
			waterpulse: ["9M"],
			yawn: ["9L21"],
			woopout: ["9L1"],
		},
	},
	hoothoot: {
		learnset: {
			acrobatics: ["9L1"],
			aerialace: ["9L1"],
			agility: ["9L1"],
			aircutter: ["9L1"],
			airslash: ["9L1"],
			amnesia: ["9L1"],
			bravebird: ["9L1"],
			calmmind: ["9L1"],
			confuseray: ["9L1"],
			confusion: ["9L1"],
			defog: ["9L1"],
			dreameater: ["9L1"],
			dualwingbeat: ["9L1"],
			echoedvoice: ["9L1"],
			endure: ["9L1"],
			extrasensory: ["9L1"],
			facade: ["9L1"],
			featherdance: ["9L1"],
			fly: ["9L1"],
			growl: ["9L1"],
			haze: ["9L1"],
			heatwave: ["9L1"],
			hypervoice: ["9L1"],
			hypnosis: ["9L1"],
			imprison: ["9L1"],
			moonblast: ["9L1"],
			nastyplot: ["9L1"],
			nightshade: ["9L1"],
			peck: ["9L1"],
			protect: ["9L1"],
			psybeam: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			raindance: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			roost: ["9L1"],
			shadowball: ["9L1"],
			skillswap: ["9L1"],
			sleeptalk: ["9L1"],
			spite: ["9L1"],
			storedpower: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			supersonic: ["9L1"],
			swift: ["9L1"],
			synchronoise: ["9L1"],
			tackle: ["9L1"],
			tailwind: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			uproar: ["9L1"],
			whirlwind: ["9L1"],
			wingattack: ["9L1"],
			zenheadbutt: ["9L1"],
		},
	},
	rabootsinnoh: {
		learnset: {
			acrobatics: ["9L1"],
			agility: ["9L1"],
			batonpass: ["9L1"],
			bounce: ["9L1"],
			bulkup: ["9L1"],
			counter: ["9L1"],
			doublekick: ["9L1"],
			doubleedge: ["9L1"],
			electroball: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			growl: ["9L1"],
			gunkshot: ["9L1"],
			headbutt: ["9L1"],
			helpinghand: ["9L1"],
			highjumpkick: ["9L1"],
			lowkick: ["9L1"],
			lowsweep: ["9L1"],
			mudshot: ["9L1"],
			protect: ["9L1"],
			quickattack: ["9L1"],
			rest: ["9L1"],
			reversal: ["9L1"],
			sandattack: ["9L1"],
			sleeptalk: ["9L1"],
			substitute: ["9L1"],
			suckerpunch: ["9L1"],
			sunnyday: ["9L1"],
			superfang: ["9L1"],
			swift: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			terablast: ["9L1"],
			trailblaze: ["9L1"],
			uturn: ["9L1"],
			weatherball: ["9L1"],
			frigidlyslide: ["9L1"],
			chillyreception: ["9L1"],
			icebeam: ["9L1"],
			blizzard: ["9L1"],
			iceball: ["9L1"],
			dragonrush: ["9L1"],
			outrage: ["9L1"],
			dracometeor: ["9L1"],
			twister: ["9L1"],
			auroraveil: ["9L1"],
			snowscape: ["9L1"],
			dragoncheer: ["9L1"],
			mist: ["9L1"],
		},
	},
	honedge: {
		learnset: {
			aerialace: ["9L1"],
			afteryou: ["9L1"],
			attract: ["9L1"],
			autotomize: ["9L1"],
			block: ["9L1"],
			brickbreak: ["9L1"],
			brutalswing: ["9L1"],
			closecombat: ["9L1"],
			confide: ["9L1"],
			cut: ["9L1"],
			destinybond: ["9L1"],
			doubleteam: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			falseswipe: ["9L1"],
			flashcannon: ["9L1"],
			frustration: ["9L1"],
			furycutter: ["9L1"],
			gyroball: ["9L1"],
			hiddenpower: ["9L1"],
			irondefense: ["9L1"],
			ironhead: ["9L1"],
			laserfocus: ["9L1"],
			magnetrise: ["9L1"],
			metalsound: ["9L1"],
			nightslash: ["9L1"],
			powertrick: ["9L1"],
			protect: ["9L1"],
			psychocut: ["9L1"],
			pursuit: ["9L1"],
			raindance: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			retaliate: ["9L1"],
			return: ["9L1"],
			reversal: ["9L1"],
			rockslide: ["9L1"],
			rocksmash: ["9L1"],
			round: ["9L1"],
			sacredsword: ["9L1"],
			screech: ["9L1"],
			secretpower: ["9L1"],
			shadowclaw: ["9L1"],
			shadowsneak: ["9L1"],
			shockwave: ["9L1"],
			slash: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			solarblade: ["9L1"],
			spite: ["9L1"],
			steelbeam: ["9L1"],
			substitute: ["9L1"],
			swagger: ["9L1"],
			swordsdance: ["9L1"],
			tackle: ["9L1"],
			toxic: ["9L1"],
			wideguard: ["9L1"],
			aegislash: ["9L1"],
		},
	},
	roselia: {
		learnset: {
			absorb: ["9L1"],
			aromatherapy: ["9L1"],
			attract: ["9L1"],
			bodyslam: ["9L1"],
			bulletseed: ["9L1"],
			captivate: ["9L1"],
			confide: ["9L1"],
			cottonspore: ["9L1"],
			covet: ["9L1"],
			cut: ["9L1"],
			dazzlinggleam: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			extrasensory: ["9L1"],
			facade: ["9L1"],
			flash: ["9L1"],
			frustration: ["9L1"],
			furycutter: ["9L1"],
			gigadrain: ["9L1"],
			grassknot: ["9L1"],
			grasswhistle: ["9L1"],
			grassyglide: ["9L1"],
			growth: ["9L1"],
			hiddenpower: ["9L1"],
			ingrain: ["9L1"],
			leafstorm: ["9L1"],
			leechseed: ["9L1"],
			lifedew: ["9L1"],
			magicalleaf: ["9L1"],
			megadrain: ["9L1"],
			mimic: ["9L1"],
			mindreader: ["9L1"],
			mudslap: ["9L1"],
			naturalgift: ["9L1"],
			naturepower: ["9L1"],
			nightmare: ["9L1"],
			petalblizzard: ["9L1"],
			petaldance: ["9L1"],
			pinmissile: ["9L1"],
			poisonjab: ["9L1"],
			poisonsting: ["9L1"],
			powerwhip: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			raindance: ["9L1"],
			razorleaf: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			round: ["9L1"],
			secretpower: ["9L1"],
			seedbomb: ["9L1"],
			shadowball: ["9L1"],
			sleeptalk: ["9L1"],
			sludgebomb: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			stunspore: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swagger: ["9L1"],
			sweetkiss: ["9L1"],
			sweetscent: ["9L1"],
			swift: ["9L1"],
			swordsdance: ["9L1"],
			synthesis: ["9L1"],
			toxic: ["9L1"],
			toxicspikes: ["9L1"],
			uproar: ["9L1"],
			venoshock: ["9L1"],
			watersport: ["9L1"],
			weatherball: ["9L1"],
			worryseed: ["9L1"],
			knockoff: ["9L1"],
		},
	},
	skiploom: {
		learnset: {
			acrobatics: ["9L1"],
			aerialace: ["9L1"],
			amnesia: ["9L1"],
			aromatherapy: ["9L1"],
			attract: ["9L1"],
			batonpass: ["9L1"],
			bounce: ["9L1"],
			captivate: ["9L1"],
			charm: ["9L1"],
			confide: ["9L1"],
			confusion: ["9L1"],
			cottonguard: ["9L1"],
			cottonspore: ["9L1"],
			curse: ["9L1"],
			dazzlinggleam: ["9L1"],
			defensecurl: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			encore: ["9L1"],
			endeavor: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			fairywind: ["9L1"],
			flash: ["9L1"],
			fling: ["9L1"],
			frustration: ["9L1"],
			gigadrain: ["9L1"],
			grassyterrain: ["9L1"],
			growl: ["9L1"],
			headbutt: ["9L1"],
			helpinghand: ["9L1"],
			hiddenpower: ["9L1"],
			infestation: ["9L1"],
			leechseed: ["9L1"],
			lightscreen: ["9L1"],
			lunge: ["9L1"],
			memento: ["9L1"],
			mimic: ["9L1"],
			naturalgift: ["9L1"],
			payday: ["9L1"],
			poisonpowder: ["9L1"],
			pollenpuff: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			ragepowder: ["9L1"],
			raindance: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			round: ["9L1"],
			secretpower: ["9L1"],
			silverwind: ["9L1"],
			sleeppowder: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			splash: ["9L1"],
			strengthsap: ["9L1"],
			stunspore: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swagger: ["9L1"],
			sweetscent: ["9L1"],
			switcheroo: ["9L1"],
			swordsdance: ["9L1"],
			synthesis: ["9L1"],
			tackle: ["9L1"],
			tailwhip: ["9L1"],
			tailwind: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			uturn: ["9L1"],
			worryseed: ["9L1"],
			defog: ["9L1"],
			hurricane: ["9L1"],
			heatwave: ["9L1"],
		},
	},
	spritzee: {
		learnset: {
			afteryou: ["9L1"],
			allyswitch: ["9L1"],
			aromatherapy: ["9L1"],
			attract: ["9L1"],
			calmmind: ["9L1"],
			captivate: ["9L1"],
			chargebeam: ["9L1"],
			charm: ["9L1"],
			confide: ["9L1"],
			covet: ["9L1"],
			dazzlinggleam: ["9L1"],
			disable: ["9L1"],
			disarmingvoice: ["9L1"],
			doubleteam: ["9L1"],
			drainingkiss: ["9L1"],
			dreameater: ["9L1"],
			echoedvoice: ["9L1"],
			encore: ["9L1"],
			endeavor: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			fairywind: ["9L1"],
			faketears: ["9L1"],
			flail: ["9L1"],
			flash: ["9L1"],
			flashcannon: ["9L1"],
			frustration: ["9L1"],
			gyroball: ["9L1"],
			healbell: ["9L1"],
			helpinghand: ["9L1"],
			hiddenpower: ["9L1"],
			lightscreen: ["9L1"],
			magiccoat: ["9L1"],
			mistyexplosion: ["9L1"],
			mistyterrain: ["9L1"],
			moonblast: ["9L1"],
			nastyplot: ["9L1"],
			odorsleuth: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			raindance: ["9L1"],
			reflect: ["9L1"],
			refresh: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			round: ["9L1"],
			secretpower: ["9L1"],
			skillswap: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swagger: ["9L1"],
			sweetkiss: ["9L1"],
			sweetscent: ["9L1"],
			telekinesis: ["9L1"],
			torment: ["9L1"],
			toxic: ["9L1"],
			trickroom: ["9L1"],
			wish: ["9L1"],
			closecombat: ["9L1"],
			uturn: ["9L1"],
			spiritbreak: ["9L1"],
		},
	},
	helioptile: {
		learnset: {
			agility: ["9L1"],
			allyswitch: ["9L1"],
			attract: ["9L1"],
			bulldoze: ["9L1"],
			camouflage: ["9L1"],
			charge: ["9L1"],
			chargebeam: ["9L1"],
			confide: ["9L1"],
			cut: ["9L1"],
			darkpulse: ["9L1"],
			dig: ["9L1"],
			doubleteam: ["9L1"],
			dragonrush: ["9L1"],
			dragontail: ["9L1"],
			electricterrain: ["9L1"],
			electrify: ["9L1"],
			electroball: ["9L1"],
			electroweb: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			flash: ["9L1"],
			frustration: ["9L1"],
			glare: ["9L1"],
			grassknot: ["9L1"],
			hiddenpower: ["9L1"],
			irontail: ["9L1"],
			lightscreen: ["9L1"],
			lowsweep: ["9L1"],
			magnetrise: ["9L1"],
			mudslap: ["9L1"],
			paraboliccharge: ["9L1"],
			pound: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			quickattack: ["9L1"],
			raindance: ["9L1"],
			razorwind: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			risingvoltage: ["9L1"],
			rockslide: ["9L1"],
			rocktomb: ["9L1"],
			round: ["9L1"],
			sandstorm: ["9L1"],
			scaleshot: ["9L1"],
			secretpower: ["9L1"],
			shockwave: ["9L1"],
			signalbeam: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			substitute: ["9L1"],
			surf: ["9L1"],
			swagger: ["9L1"],
			swift: ["9L1"],
			tailwhip: ["9L1"],
			thunder: ["9L1"],
			thundershock: ["9L1"],
			thunderwave: ["9L1"],
			thunderbolt: ["9L1"],
			toxic: ["9L1"],
			uturn: ["9L1"],
			voltswitch: ["9L1"],
			wildcharge: ["9L1"],
			powergem: ["9L1"],
			meteorbeam: ["9L1"],
			stealthrock: ["9L1"],
			rockblast: ["9L1"],
			earthpower: ["9L1"],
		},
	},
	piplup: {
		learnset: {
			aerialace: ["9L1"],
			agility: ["9L1"],
			aquaring: ["9L1"],
			blizzard: ["9L1"],
			brickbreak: ["9L1"],
			brine: ["9L1"],
			bubblebeam: ["9L1"],
			charm: ["9L1"],
			chillingwater: ["9L1"],
			disarmingvoice: ["9L1"],
			drillpeck: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			featherdance: ["9L1"],
			fling: ["9L1"],
			flipturn: ["9L1"],
			furyattack: ["9L1"],
			grassknot: ["9L1"],
			growl: ["9L1"],
			haze: ["9L1"],
			helpinghand: ["9L1"],
			hydropump: ["9L1"],
			icebeam: ["9L1"],
			icespinner: ["9L1"],
			icywind: ["9L1"],
			liquidation: ["9L1"],
			mist: ["9L1"],
			peck: ["9L1"],
			pound: ["9L1"],
			powertrip: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			raindance: ["9L1"],
			rest: ["9L1"],
			rocktomb: ["9L1"],
			roost: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			snowscape: ["9L1"],
			substitute: ["9L1"],
			supersonic: ["9L1"],
			surf: ["9L1"],
			swagger: ["9L1"],
			swift: ["9L1"],
			terablast: ["9L1"],
			tripleaxel: ["9L1"],
			watergun: ["9L1"],
			waterpledge: ["9L1"],
			waterpulse: ["9L1"],
			waterfall: ["9L1"],
			weatherball: ["9L1"],
			whirlpool: ["9L1"],
			yawn: ["9L1"],
			makeitrain: ["9L1"],
			steelbeam: ["9L1"],
		},
	},
};
